import React from 'react';

export default function Footer() {
  return (
    <div id="footer">
      <h2>Math Magician project</h2>
      <h3>By:- Yemisirach Tamirat.</h3>
    </div>
  );
}
